
function currentLocationLabel(state = '', action){
	switch(action.type){
		case 'SELECT_LOCATION':
		return  action.selectedLocation

		case 'CLOSE_LOCATION':
		return  ''

		default : 
		return state;

	}
}

export default currentLocationLabel;


// WEBPACK FOOTER //
// ./src/js/reducers/currentLocationLabel.js